import { post } from '@dehaat/kisan-app-bl/axios/kheti'

import { IvrBody } from '@/models/ProductInsurance'

const generateCartOtpIvr = (body: IvrBody) =>
  post<{ message: string }>('/pos/v1/trigger-otp-ivr', body as never)

export default generateCartOtpIvr
